define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/special-occasion/specialOccasionEventsTableView.tmpl");

    var SpecialOccasionEventsTableRowView = require("manager-views/special-occasion/SpecialOccasionEventsTableRowView");
    var SpecialOccasionEventsTableEmptyView = require("manager-views/special-occasion/SpecialOccasionEventsTableEmptyView");

    var SpecialOccasionEventsTableView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventsTableView = Marionette.GridView.extend({
            template : template,
            itemView: SpecialOccasionEventsTableRowView,
            emptyView: SpecialOccasionEventsTableEmptyView,
            itemViewContainer : "tbody",
            selectedItem: null,
            className: "table-main ui-table",

            ui: {
                timeFrameHeader: ".time-frame .wrap .content"
            },

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.itemViewOptions = {channel: this.channel};
            },

            triggerTimeFrameSort: function() {
                this.ui.timeFrameHeader.trigger("click");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventsTableView;
});
